"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useFocused = _interopRequireDefault(require("../hooks/useFocused"));

var FocusProvider = function FocusProvider(props) {
  return props.children((0, _useFocused.default)(props));
};

FocusProvider.displayName = 'FocusProvider';
var _default = FocusProvider;
exports.default = _default;
module.exports = exports.default;